<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <v-text-field
      slot="activator"
      v-model="time"
      label="Hora"
      single-line
      prepend-icon="access_time"
      readonly
      :error-messages="errorMessages"
    ></v-text-field>
    <v-time-picker light v-model="time" full-width></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  props: {
    value: String,
    errorMessages: {
      type: Array,
      default: () => { return [] }
    }
  },

  computed: {
    time: {
      set (newValue) {
        this.inputTime(newValue)
      },
      get () {
        return this.value
      }
    }
  },

  data () {
    return {
      menu: false
    }
  },

  methods: {
    inputTime (value) {
      this.menu = false
      this.$emit('input', value)
    }
  }
}
</script>
